var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.53033 3.46967C4.23744 3.17678 3.76256 3.17678 3.46967 3.46967C3.17678 3.76256 3.17678 4.23744 3.46967 4.53033L8.93933 10L3.46967 15.4697C3.17678 15.7626 3.17678 16.2374 3.46967 16.5303C3.76256 16.8232 4.23744 16.8232 4.53033 16.5303L9.99999 11.0607L15.4697 16.5303C15.7626 16.8232 16.2374 16.8232 16.5303 16.5303C16.8232 16.2374 16.8232 15.7626 16.5303 15.4697L11.0606 10L16.5303 4.53033C16.8232 4.23744 16.8232 3.76256 16.5303 3.46967C16.2374 3.17678 15.7626 3.17678 15.4697 3.46967L9.99999 8.93934L4.53033 3.46967ZM9.99999 8.93934L8.93933 10L9.99999 11.0607L11.0606 10L9.99999 8.93934Z",
    fill: "#667085"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99999 8.93934L8.93933 10L9.99999 11.0607L11.0606 10L9.99999 8.93934Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "9735164cb159ca667a716cb158818137.svg";
export { ForwardRef as ReactComponent };